import { makeObservable } from 'mobx'

import { EMPTY_STRING_ID } from '@/constant/common'
import stringUtils from '@/utils/String/stringUtils'

import { DTO } from '../DTO'
import { SchoolGrade } from './SchoolGrade'

/***
 * @see StudentController
 ***/
export class Student extends DTO {
  id = EMPTY_STRING_ID
  loginId = ''
  status: res.Student['status'] = 'ACTIVE'
  name = ''
  schoolGrade = new SchoolGrade()
  phoneNumber = ''
  attendanceCode = ''
  memo = ''
  parent = {
    id: '',
    phoneNumber: '',
    loginId: '',
  }
  isVirtual = false // 가상 학생 여부
  serviceTypes: res.Student['serviceTypes'] = []

  constructor({ schoolType, grade, ...data }: Partial<res.Student & { isVirtual?: boolean }> = {}) {
    super()
    if (data) {
      this.updateExceptNullable<Student>(this, {
        ...data,
        schoolGrade: new SchoolGrade({ schoolType, grade }),
      })
    }
    makeObservable(this)
  }

  get isEnglishflatAllowed() {
    return this.serviceTypes?.includes('ENGLISHFLAT') ?? false
  }

  get isScienceflatAllowed() {
    return this.serviceTypes?.includes('SCIENCEFLAT') ?? false
  }

  get isMathflatAllowed() {
    return this.serviceTypes?.includes('MATHFLAT') ?? false
  }

  get korStatus() {
    if (this.status === 'ACTIVE') return '재원'
    if (this.status === 'INACTIVE') return '퇴원'
    return '삭제'
  }

  get numericLoginId() {
    if (this.loginId) return this.loginId.replace(/^[sp]/gi, '')
  }

  get dashedPhone() {
    try {
      return stringUtils.toDashedPhone(this.phoneNumber)
    } catch (error) {
      return this.phoneNumber
    }
  }

  get dashedParentPhone() {
    try {
      return stringUtils.toDashedPhone(this.parent.phoneNumber)
    } catch (error) {
      return this.parent.phoneNumber
    }
  }
}
